/**
 * Utility function to format the data as it is expected for GA. The format is DD/MM/YYYY.
 * @param date
 */
export const formatDate = (date: string) => {
  if (!date) {
    return undefined;
  }
  const matches = date?.match(/(?<year>\d{4})-(?<month>\d{2})-(?<day>\d{2})/);

  if (!matches) {
    return undefined;
  }

  return `${matches[3]}/${matches[2]}/${matches[1]}`;
};
